import { ScreenLayout } from 'src/components/screen-layout/ScreenLayout'

export const HomePage = () => {
  return <ScreenLayout title='Home'>This is body of the home page. </ScreenLayout>
}
